import { all, put, takeEvery } from "redux-saga/effects";
import { fetcher, getErrorMsg, handleError } from "lib/fetch";
import * as actions from "./actions";

const url = "structures";

function* loadStructures(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(url, params, token);
    yield put(actions.loadStructures.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.loadStructures.failure(getErrorMsg(error)));
  }
}

function* showStructure(action) {
  try {
    const { id, token } = action.payload;
    const res = yield fetcher.get(`${url}/${id}`, token);
    yield put(actions.showStructure.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.showStructure.failure(getErrorMsg(error)));
  }
}

function* createStructure(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(`${url}/create`, params, token);
    yield put(actions.createStructure.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.createStructure.failure(getErrorMsg(error)));
  }
}

function* updateStructure(action) {
  try {
    const { params, id, token } = action.payload;

    let data = {};
    Object.getOwnPropertyNames(params).forEach(function (val, idx, array) {
      if (val !== "sub_structure" && val !== "fileList_icon_src") {
        data[val] = params[val];
      }
    });

    const res = yield fetcher.post(`${url}/update/${id}`, data, token);
    yield put(actions.updateStructure.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.updateStructure.failure(getErrorMsg(error)));
  }
}

function* deleteStructure(action) {
  try {
    const { id, token } = action.payload;
    yield fetcher.get(`${url}/delete/${id}`, token);
    yield put(actions.deleteStructure.success(id));
  } catch (error) {
    handleError(error);
    yield put(actions.deleteStructure.failure(getErrorMsg(error)));
  }
}

function* importStructure(action) {
  try {
    const { file, token } = action.payload;
    const formData = new FormData();
    formData.append("file_name", file.originFileObj);
    const res = yield fetcher.upload(`${url}/import`, formData, token);
    yield put(actions.importStructure.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.importStructure.failure(getErrorMsg(error)));
  }
}

function* exportStructure(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(`${url}/export`, params, token);
    yield put(actions.exportStructure.success(res.data));
    fetcher.download(res.data.data);
  } catch (error) {
    handleError(error);
    yield put(actions.exportStructure.failure(getErrorMsg(error)));
  }
}

export default function* watchStructure() {
  yield all([
    takeEvery(actions.LOAD_STRUCTURE.REQUEST, loadStructures),
    takeEvery(actions.SHOW_STRUCTURE.REQUEST, showStructure),
    takeEvery(actions.CREATE_STRUCTURE.REQUEST, createStructure),
    takeEvery(actions.UPDATE_STRUCTURE.REQUEST, updateStructure),
    takeEvery(actions.DELETE_STRUCTURE.REQUEST, deleteStructure),
    takeEvery(actions.IMPORT_STRUCTURE.REQUEST, importStructure),
    takeEvery(actions.EXPORT_STRUCTURE.REQUEST, exportStructure),
  ]);
}
